/* ------------------------------------------------------------------------- *
 * "Complete The Uniform" card swatches
 * Clicking a colour swatch swaps the card image and updates the add-to-cart
 * variant (colour + size), mirroring the PLP swatch behaviour.
 *
 * Loaded as a normal asset (not inline in the snippet) because the cards are
 * injected into <product-recommendations> via innerHTML, which never runs
 * inline <script> tags. Click handling uses event delegation on document and
 * a MutationObserver so it works on cards that appear after load.
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.__cuCardSwatchInit) return;
  window.__cuCardSwatchInit = true;

  function withWidth(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function getVariants(card) {
    var el = card.querySelector('.cu-card__variants');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function optForPosition(v, pos) {
    return pos === 1 ? v.o1 : pos === 2 ? v.o2 : pos === 3 ? v.o3 : null;
  }

  function selectColor(card, color) {
    var colorPos = parseInt(card.getAttribute('data-color-position'), 10) || 0;
    var sizePos = parseInt(card.getAttribute('data-size-position'), 10) || 0;
    var productUrl = card.getAttribute('data-product-url') || '';
    var variants = getVariants(card);
    if (!colorPos) return;

    var colorVariants = variants.filter(function (v) {
      return optForPosition(v, colorPos) === color;
    });
    if (!colorVariants.length) return;

    // Mark the clicked swatch selected.
    card.querySelectorAll('.cu-card__swatch').forEach(function (s) {
      s.classList.toggle('is-selected', s.getAttribute('data-color') === color);
    });

    // Swap the card image to this colour's representative image.
    var imgVariant = colorVariants.find(function (v) { return v.image; }) || colorVariants[0];
    var img = card.querySelector('.cu-card__image');
    if (img && imgVariant && imgVariant.image) {
      img.src = withWidth(imgVariant.image, 400);
      img.srcset = withWidth(imgVariant.image, 200) + ' 200w, ' +
                   withWidth(imgVariant.image, 400) + ' 400w, ' +
                   withWidth(imgVariant.image, 600) + ' 600w';
    }

    // Rebuild the size <select> for this colour so Add To Bag adds the correct
    // variant. Keep the current size if it exists in this colour.
    var select = card.querySelector('.cu-card__select');
    var chosen = null;
    if (select && sizePos) {
      var prevSize = null;
      var prevOpt = select.options[select.selectedIndex];
      if (prevOpt) prevSize = prevOpt.getAttribute('data-size');

      select.querySelectorAll('option').forEach(function (opt) {
        var size = opt.getAttribute('data-size');
        var match = colorVariants.find(function (v) {
          return optForPosition(v, sizePos) === size;
        });
        if (match) {
          opt.value = match.id;
          opt.disabled = !match.available;
          opt.hidden = false;
        } else {
          opt.disabled = true;
          opt.hidden = true;
        }
      });

      var keep = prevSize && colorVariants.find(function (v) {
        return optForPosition(v, sizePos) === prevSize && v.available;
      });
      chosen = keep || colorVariants.find(function (v) { return v.available; }) || colorVariants[0];
      if (chosen) select.value = chosen.id;
    } else {
      // No size dropdown: update the hidden variant id.
      chosen = colorVariants.find(function (v) { return v.available; }) || colorVariants[0];
      var hidden = card.querySelector('input[name="id"].product-variant-id');
      if (hidden && chosen) hidden.value = chosen.id;
    }

    // Point the card links at the chosen variant.
    if (chosen && productUrl) {
      var href = productUrl.split('?')[0] + '?variant=' + chosen.id;
      card.querySelectorAll('.cu-card__media-link, .cu-card__title-row').forEach(function (a) {
        a.href = href;
      });
    }
  }

  function onActivate(e) {
    var swatch = e.target.closest && e.target.closest('.cu-card__swatch');
    if (!swatch) return;
    var card = swatch.closest('.cu-card');
    if (!card) return;
    selectColor(card, swatch.getAttribute('data-color'));
  }

  document.addEventListener('click', onActivate);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (!t.classList || !t.classList.contains('cu-card__swatch')) return;
    e.preventDefault();
    onActivate(e);
  });

  // Sync each card's size options + variant id with its initially selected
  // colour so Add To Bag is correct before any click.
  function initCards(scope) {
    var root = scope || document;
    var cards = [];
    if (root.matches && root.matches('.cu-card')) cards.push(root);
    if (root.querySelectorAll) root.querySelectorAll('.cu-card').forEach(function (c) { cards.push(c); });
    cards.forEach(function (card) {
      if (card.dataset.cuSwatchReady === 'true') return;
      card.dataset.cuSwatchReady = 'true';
      var sel = card.querySelector('.cu-card__swatch.is-selected') ||
                card.querySelector('.cu-card__swatch');
      if (sel) selectColor(card, sel.getAttribute('data-color'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCards(); });
  } else {
    initCards();
  }

  // Cards are injected into <product-recommendations> after fetch — watch for them.
  var observer = new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) initCards(node);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (e) { initCards(e.target); });
})();
